import { useCallback } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Creates goBack function that will use browser back if provided location state key is `true`
 * to preserve filter values in url search params. If location state key is not set it will navigate
 * to the provided route as a fallback.
 * @param route Route string to use as key for location state & default fallback navigation route
 * @returns Function that will either trigger browser back or navigate to the provided route
 */
export const useNavigateBack = (route: string) => {
  const navigate = useNavigate();
  const { state: locationState } = useLocation();

  const goBack = useCallback(() => {
    if (locationState?.[route] === true) navigate(-1);
    else navigate(route);
  }, [locationState, navigate, route]);

  return goBack;
};
